module.exports = __webpack_public_path__ + "static/media/gearsThumb.1a914527.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/gearsThumb.jpg
// module id = 393
// module chunks = 0